export const cssMultiLevelMenu = {
    marginTop: 10,
    width: '250px',
    /*  '&:hover': {
         backgroundColor: 'gray',
     }, */
};